import { useState } from "react";
import Invoice from "./invoice";
import moment from "moment";
import { formatPrice } from "utils/convertNumbThousand";

function getPeriods(duration: number, nature: string, invoice?: any) {
  const results = [];
  let current = invoice?.pick_up_time ? moment(invoice.pick_up_time) : moment();
  let firstEnd = invoice?.drop_off_time ? moment(invoice.drop_off_time) : null;

  for (let i = 0; i < duration; i++) {
    let end;
    if (i === 0 && firstEnd) {
      end = firstEnd.clone();
    } else {
      end = nature === "weekly"
        ? current.clone().add(7, "days")
        : current.clone().add(30, "days");
    }
    
    results.push({
      label: nature === "weekly" ? `Week ${i + 1}` : `Month ${i + 1}`,
      range: `${current.format("MMM D")} - ${end.format("MMM D")}`,
    });
    current = end.clone();
  }

  return results;
}

const LongTermRentalInvoice = ({
  long_term_rental_nature,
  long_term_rental_duration,
  invoice,
  carName,
}: any) => {
  const [openIndex, setOpenIndex] = useState<number>(-1);
  const periods = getPeriods(
    long_term_rental_duration,
    long_term_rental_nature,
    invoice,
  );

 

  return (
    <div className="rounded-xl w-full">
      <h2 className="text-2xl font-bold text-text-color mb-3">
        Booking Invoice
      </h2>

      {periods.map((period, idx) => (
        <div key={idx} className="my-2 border border-secondary-100 rounded-lg">
          <button
            className="flex justify-between items-center w-full px-4 py-3 focus:outline-none"
            onClick={() => setOpenIndex(idx === openIndex ? -1 : idx)}
            aria-expanded={openIndex === idx}
          >
            <span className="text-left">
              <span className="text-lg font-[600] text-text-color">
                {period.label}
              </span>
              <br />
              <span className="text-base font-[400] text-text-color">
                {period.range}
              </span>
            </span>

            <span className="text-left">
              <span className="text-lg font-[600] text-text-color">Amount</span>
              <br />
              <span className="text-base font-[400] text-text-color">
                ${formatPrice(invoice?.total_price_without_security)}
              </span>
            </span>
            <span className="ml-3 text-base text-primary-100">
              {openIndex === idx ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 15.665C5 15.665 9.4189 9.66504 11 9.66504C12.5812 9.66504 17 15.665 17 15.665"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 8.33501C19 8.33501 14.5811 14.335 13 14.335C11.4188 14.335 7 8.33496 7 8.33496"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              )}
            </span>
          </button>
          {openIndex === idx && (
            <div className="px-4 pb-4  border-t border-secondary-100">
              <Invoice invoice={invoice} carName={carName} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default LongTermRentalInvoice;
